<div class="my-32">
    <table class="simple">
        <thead>
            <tr>
                <th>{{'Name' | translate }}</th>
                <th>{{'Type' | translate }}</th>
                <th fxHide.xs>{{'Date' | translate }}</th>
                <th><span fxHide.xs>{{'Download' | translate }}</span></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of downloads">
                <td>
                    <span>{{item.name}}</span>
                </td>
                <td>
                    <span>{{item.custom_properties.description}}</span>
                </td>
                <td fxHide.xs>
                    <span class="text-truncate">{{item.updated_at}}</span>
                </td>
                <td>
                    <button mat-icon-button
                        (click)="downloadDocument(item.id, item.file_name)">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="downloads && downloads.length === 0">
                <td colspan="5" class="empty">{{'No data' | translate }}</td>
            </tr>
        </tbody>
    </table>
</div>
